export const getBasisTypeNameFromId = (
    basisTypeId: number | undefined
): 'Massage' | 'Training' | 'Yoga' => {
    // Shall we add trnaslation here?
    switch (basisTypeId) {
        case 1:
            return 'Massage'
        case 2:
            return 'Training'
        case 3:
            return 'Yoga'
        default:
            return 'Massage'
    }
}
